export default "__VITE_ASSET__b76f30c1__"